// Used in assignable-expanded-composite.component.html

// Angular
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { MatCheckboxChange } from "@angular/material/checkbox";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";

// Components
import { TaskCategoryDialogComponent } from "#components/content-library/assignable-expanded/task-category-dialog/task-category-dialog.component";

// RXJS/Store
import * as profileStore from "#login/store";
import { Store, select } from "@ngrx/store";

// Services/Types/Helpers
import { Asset, Bundle } from "@carnegie-learning/cure-types";
import { SelectedAssets, PPUser as User } from "cli-types";

@Component({
    selector: "assignable-task-categories",
    templateUrl: "./assignable-task-categories.component.html",
    styleUrls: ["./assignable-task-categories.component.scss"],
    standalone: false
})
export class TaskCategoriesAssignableComponent implements OnInit {
    userProfile: User;

    @Input() taskCategories: Asset[];
    @Input() selectedAssets: SelectedAssets;
    @Input() creatingLesson: boolean;

    @Output() toggleCategoryEvent = new EventEmitter<any>();

    constructor(
        private categoryDialog: MatDialog,
        public profile_store: Store<profileStore.UserState>
    ) {}

    ngOnInit() {
        this.profile_store
            .pipe(select(profileStore.getUserProfile))
            .subscribe((userProfile) => {
                if (userProfile) {
                    this.userProfile = userProfile;
                }
            });
    }

    trackByCategory(index: number, category: Asset) {
        return category.assetId;
    }

    openCategoryDialog(category: Asset) {
        const categoryDialogConfig = new MatDialogConfig();
        categoryDialogConfig.autoFocus = true;
        categoryDialogConfig.data = category;

        this.categoryDialog.open(
            TaskCategoryDialogComponent,
            categoryDialogConfig
        );
    }

    isCategorySelected(category: Asset) {
        return this.selectedAssets.assets.find(
            (a) => a.assetId === category.assetId
        );
    }

    toggleCategory(event: MatCheckboxChange, category: Asset) {
        this.toggleCategoryEvent.emit({
            checked: event.checked,
            asset: category,
        });
    }

    getCategoryOrder(asset: Asset) {
        return (<Bundle>asset).categoryOrder;
    }
}
